import { GeofenceRule } from 'services/resources';

export const START_LOADING = 'app/services/Geofences/START_LOADING';

export const GET_GEOFENCES_SUCCESS = 'app/services/Geofences/GET_GEOFENCES_SUCCESS';
export const GET_GEOFENCES_FAIL = 'app/services/Geofences/GET_GEOFENCES_FAIL';
export const ADD_GEOFENCE_SUCCESS = 'app/services/Geofences/ADD_GEOFENCE_SUCCESS';
export const ADD_GEOFENCE_FAIL = 'app/services/Geofences/ADD_GEOFENCE_FAIL';
export const UPDATE_GEOFENCE_SUCCESS = 'app/services/Geofences/UPDATE_GEOFENCE_SUCCESS';
export const UPDATE_GEOFENCE_FAIL = 'app/services/Geofences/UPDATE_GEOFENCE_FAIL';
export const DELETE_GEOFENCE_SUCCESS = 'app/services/Geofences/DELETE_GEOFENCE_SUCCESS';
export const DELETE_GEOFENCE_FAIL = 'app/services/Geofences/DELETE_GEOFENCE_FAIL';
export const GET_GEOFENCE_RULES_SUCCESS = 'app/services/Geofences/GET_GEOFENCE_RULES_SUCCESS';
export const GET_GEOFENCE_RULES_FAIL = 'app/services/Geofences/GET_GEOFENCE_RULES_FAIL';
export const UPDATE_GEOFENCE_RULE_SUCCESS = 'app/services/Geofences/PATCH_GEOFENCE_RULE_SUCCESS';
export const UPDATE_GEOFENCE_RULE_FAIL = 'app/services/Geofences/PATCH_GEOFENCE_RULE_FAIL';
export const CREATE_GEOFENCE_RULE_SUCCESS = 'app/services/Geofences/CREATE_GEOFENCE_RULE_SUCCESS';
export const CREATE_GEOFENCE_RULE_FAIL = 'app/services/Geofences/CREATE_GEOFENCE_RULE_FAIL';
export const DELETE_GEOFENCE_RULE_SUCCESS = 'app/services/Geofences/DELETE_GEOFENCE_RULE_SUCCESS';
export const DELETE_GEOFENCE_RULE_FAIL = 'app/services/Geofences/DELETE_GEOFENCE_RULE_FAIL';

export const startLoading = () => ({
  type: START_LOADING,
});

export const receivedGeofencesSuccess = (data) => ({
  type: GET_GEOFENCES_SUCCESS,
  payload: { data },
});

export const receivedGeofencesFail = (errors) => ({
  type: GET_GEOFENCES_FAIL,
  payload: { errors },
});

export const receivedAddGeofencesSuccess = (geofence) => ({
  type: ADD_GEOFENCE_SUCCESS,
  payload: { geofence },
});

export const receivedAddGeofencesFail = (errors) => ({
  type: ADD_GEOFENCE_FAIL,
  payload: { errors },
});

export const receivedUpdateGeofencesSuccess = (geofence) => ({
  type: UPDATE_GEOFENCE_SUCCESS,
  payload: { geofence },
});

export const receivedUpdateGeofencesFail = (errors) => ({
  type: UPDATE_GEOFENCE_FAIL,
  payload: { errors },
});

export const receivedDeleteGeofenceSuccess = (id) => ({
  type: DELETE_GEOFENCE_SUCCESS,
  payload: { id },
});

export const receivedDeleteGeofenceFail = (errors) => ({
  type: DELETE_GEOFENCE_FAIL,
  payload: { errors },
});

export const receivedGetGeofenceRulesSuccess = (data: GeofenceRule[]) => ({
  type: GET_GEOFENCE_RULES_SUCCESS,
  payload: { data },
});

export const receivedGetGeofenceRulesFail = (errors) => ({
  type: GET_GEOFENCE_RULES_FAIL,
  payload: { errors },
});

export const receivedUpdateGeofenceRuleSuccess = (rule: GeofenceRule) => ({
  type: UPDATE_GEOFENCE_RULE_SUCCESS,
  payload: { rule },
});

export const receivedUpdateGeofenceRuleFail = (errors) => ({
  type: UPDATE_GEOFENCE_RULE_FAIL,
  payload: { errors },
});

export const receivedCreateGeofenceRuleSuccess = (rule: GeofenceRule) => ({
  type: CREATE_GEOFENCE_RULE_SUCCESS,
  payload: { rule },
});

export const receivedCreateGeofenceRuleFail = (errors) => ({
  type: CREATE_GEOFENCE_RULE_FAIL,
  payload: { errors },
});

export const receivedDeleteGeofenceRuleSuccess = (id) => ({
  type: DELETE_GEOFENCE_RULE_SUCCESS,
  payload: { id },
});

export const receivedDeleteGeofenceRuleFail = (errors) => ({
  type: DELETE_GEOFENCE_RULE_FAIL,
  payload: { errors },
});
